import { useState } from 'react'

import { downloadFile } from '@avantstay/backoffice-core'

import { GuestInboxTimelineAttachment } from '@new/domains/operations/components/StayTimeline/StayTimeline.types'

import { getDownloadName } from '../MessageAttachments.utils'

export const useAttachmentDownload = () => {
  const [downloadingIds, setDownloadingIds] = useState<string[]>([])

  const isDownloading = (attachment: GuestInboxTimelineAttachment) => {
    return downloadingIds.includes(attachment.id)
  }

  const download = async (attachment: GuestInboxTimelineAttachment) => {
    if (isDownloading(attachment)) return

    setDownloadingIds(ids => [...ids, attachment.id])
    try {
      await downloadFile(attachment.url, getDownloadName(attachment))
    } finally {
      setDownloadingIds(ids => ids.filter(id => id !== attachment.id))
    }
  }

  return { isDownloading, download }
}
